import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

export default function WeeklyChart() {
  // Données plus réalistes pour une semaine type
  const data = [
    {
      day: 'Lun',
      'Entrées Aériennes': 245,
      'Entrées Terrestres': 678,
      'Sorties Aériennes': 198,
      'Sorties Terrestres': 523,
      'Voyages Internes': 892
    },
    {
      day: 'Mar',
      'Entrées Aériennes': 312,
      'Entrées Terrestres': 745,
      'Sorties Aériennes': 267,
      'Sorties Terrestres': 612,
      'Voyages Internes': 967
    },
    {
      day: 'Mer',
      'Entrées Aériennes': 278,
      'Entrées Terrestres': 834,
      'Sorties Aériennes': 234,
      'Sorties Terrestres': 678,
      'Voyages Internes': 1023
    },
    {
      day: 'Jeu',
      'Entrées Aériennes': 389,
      'Entrées Terrestres': 912,
      'Sorties Aériennes': 345,
      'Sorties Terrestres': 745,
      'Voyages Internes': 1156
    },
    {
      day: 'Ven',
      'Entrées Aériennes': 423,
      'Entrées Terrestres': 1023,
      'Sorties Aériennes': 378,
      'Sorties Terrestres': 867,
      'Voyages Internes': 1289
    },
    {
      day: 'Sam',
      'Entrées Aériennes': 289,
      'Entrées Terrestres': 767,
      'Sorties Aériennes': 245,
      'Sorties Terrestres': 634,
      'Voyages Internes': 945
    },
    {
      day: 'Dim',
      'Entrées Aériennes': 234,
      'Entrées Terrestres': 589,
      'Sorties Aériennes': 189,
      'Sorties Terrestres': 478,
      'Voyages Internes': 867
    }
  ];

  // Configuration personnalisée pour le tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-4 border rounded-lg shadow-lg">
          <p className="font-bold text-gray-800 mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color }} className="text-sm">
              {entry.name}: {entry.value.toLocaleString()} voyageurs
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-bold">Tendance Hebdomadaire des Voyages</h3>
        <div className="text-sm text-gray-500">
          Total hebdomadaire: {data.reduce((acc, curr) => 
            acc + curr['Entrées Aériennes'] + curr['Entrées Terrestres'] + 
            curr['Sorties Aériennes'] + curr['Sorties Terrestres'] + 
            curr['Voyages Internes'], 0).toLocaleString()} voyageurs
        </div>
      </div>

      <div className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar dataKey="Entrées Aériennes" stackId="entrees" fill="#f97316" /> {/* Orange */}
            <Bar dataKey="Entrées Terrestres" stackId="entrees" fill="#fb923c" /> {/* Orange clair */}
            <Bar dataKey="Sorties Aériennes" stackId="sorties" fill="#15803d" /> {/* Vert */}
            <Bar dataKey="Sorties Terrestres" stackId="sorties" fill="#22c55e" /> {/* Vert clair */}
            <Bar dataKey="Voyages Internes" fill="#6366f1" /> {/* Bleu violet - Nouvelle couleur plus visible */}
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-4 text-sm text-gray-600">
        <div className="space-y-1">
          <div className="font-semibold">Points clés :</div>
          <div>• Pic d'activité : Vendredi</div>
          <div>• Plus calme : Dimanche</div>
        </div>
        <div className="space-y-1">
          <div className="font-semibold">Tendances :</div>
          <div>• Hausse des entrées aériennes</div>
          <div>• Stabilité des voyages internes</div>
        </div>
      </div>
    </div>
  );
}